import { useTranslation } from 'react-i18next'

import { DetailPerson } from 'entities/close-circle/ui/detail-person'

import { HeaderGoBack } from 'shared/ui/header-go-back'

const CloseCircleDetail = () => {
  const { t } = useTranslation()

  return (
    <div>
      <HeaderGoBack
        title={t('сlose_circlу')}
        buttonWhite
      />

      <DetailPerson />
    </div>
  )
}

export default CloseCircleDetail
